<!-- ProfileIcon.vue -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M12.8487 18.4513C15.5018 18.4513 17.6526 16.005 17.6526 12.9874C17.6526 9.96973 15.5018 7.52344 12.8487 7.52344C10.1957 7.52344 8.04492 9.96973 8.04492 12.9874C8.04492 16.005 10.1957 18.4513 12.8487 18.4513Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M17.9819 8.6543H7.59324C7.25589 8.6543 6.98242 8.92777 6.98242 9.26511V11.185C6.98242 11.5224 7.25589 11.7959 7.59324 11.7959H17.9819C18.3192 11.7959 18.5927 11.5224 18.5927 11.185V9.26511C18.5927 8.92777 18.3192 8.6543 17.9819 8.6543Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M15.4569 5.60516C16.5058 5.60516 17.3561 4.75483 17.3561 3.7059C17.3561 2.65697 16.5058 1.80664 15.4569 1.80664C14.4079 1.80664 13.5576 2.65697 13.5576 3.7059C13.5576 4.75483 14.4079 5.60516 15.4569 5.60516Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M11.0625 8.80078V11.2854"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M17.652 10.0427C17.4754 7.52786 16.6626 5.89742 14.2336 5.60633C11.8636 5.3216 8.71085 7.38947 7.92188 10.0427H17.652Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M20.0572 23.1935C18.8371 20.3987 16.0519 18.4453 12.8069 18.4453C9.56353 18.4453 6.77668 20.3987 5.55664 23.1935H20.0572Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M11.165 14.9434C11.515 15.5828 12.1369 16.0091 12.848 16.0091C13.559 16.0091 14.1825 15.5828 14.5309 14.9434"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>
